module.exports = __webpack_public_path__ + "media/images/backgrounds/background-feature-performance-vertical-a67f5cbe96fe7d0d5960bcdc085c56a1.svg";